import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PerfilRiesgo } from '../../_models/perfil-riesgo';
import { PerfilRiesgoService } from '../../_services/perfil-riesgo.service';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AppSettings } from '../../../proyect.conf';
import { AdjuntoService } from '../../_services/adjunto.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { forkJoin } from 'rxjs';
import { EstadoService } from '../../_services/estado.service';
import { Estado } from '../../_models/estado';
import { PerfilRiesgoEstado } from '../../_models/perfil-riesgo-estado';
import { PerfilRiesgoEstadoService } from '../../_services/perfil-riesgo-estado.service';
import { PerfilRiesgoEstadoAutomaticoService } from '../../_services/perfil-riesgo-estado-automatico.service';
import { PerfilRiesgoEstadoAutomatico } from '../../_models/perfil-riesgo-estado-automatico';

@Component( {
  selector: 'app-perfiles-riesgo-editar',
  templateUrl: 'perfiles-riesgo-editar.component.html'
} )

export class PerfilesRiesgoEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  perfil: PerfilRiesgo;
  lisPerfiles: PerfilRiesgo[] = [];
  tabSeleccionado = 'INFO';
  formulario: FormGroup;
  submitted = false;
  superaMaximo = false;
  carImagen = false;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  imagen: SafeResourceUrl;
  nomArchivo: string;
  lisCausales: SelectItem[] = [];
  lisEstados: SelectItem[] = [];
  nextOrder = 1;
  perRiesgoEstado: PerfilRiesgoEstado;
  perRiesgoEstadoAutomatico: PerfilRiesgoEstadoAutomatico;

  constructor( private perRiesgoServicio: PerfilRiesgoService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private adjServicio: AdjuntoService,
               private sanitizer: DomSanitizer,
               private autServicio: AutenticacionService,
               private lisServicio: ListaService,
               private conServicio: ConfirmationService,
               private serEstados: EstadoService,
               private perRiesgoEstadoServicio: PerfilRiesgoEstadoService,
               private perRiesgoEstadoAutomaticoServicio: PerfilRiesgoEstadoAutomaticoService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        const idPerfilRiesgo = params[ 'id' ];
        forkJoin( this.perRiesgoServicio.obtenerPorId( idPerfilRiesgo ),
          this.perRiesgoEstadoServicio.obtenerPorPerfilRiesgo( idPerfilRiesgo ),
          this.perRiesgoEstadoAutomaticoServicio.obtenerPorPerfilRiesgo( idPerfilRiesgo ) ).subscribe( ( [ perfil, perEstado, perEstadoAutomatico ] ) => {
          this.perfil = perfil;
          this.perRiesgoEstado = perEstado;
          this.perRiesgoEstadoAutomatico = perEstadoAutomatico;
          // this.adjServicio.descargarArchivo( this.perfil.idAdjunto ).subscribe( adjunto => {
          let reader = new FileReader();
          reader.addEventListener( 'load', () => {
            this.imagen = reader.result;
          }, false );
          // if ( adjunto ) {
          //   reader.readAsDataURL( adjunto );
          // }
          this.carServiciosIniciales();
        } );
        // } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  carServiciosIniciales() {
    forkJoin( this.perRiesgoServicio.listado(),
      this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ),
      this.serEstados.listado() ).subscribe( ( [ perfiles, lisCausales, estados ] ) => {
      this.lisPerfiles = perfiles;
      estados.map( ( x: Estado ) => {
        this.lisEstados.push( { label: x.nombre, value: x.idEstado } );
      } );
      this.sortItems();
      if ( this.lisPerfiles.length > 0 ) {
        this.nextOrder = this.lisPerfiles[ this.lisPerfiles.length - 1 ].orden;
        this.nextOrder = this.nextOrder ? (this.nextOrder + 1) : 1;
      }
      this.cargarFormulario();
      lisCausales.map( ( s: ListaItem ) => {
        this.lisCausales.push( { label: s.nombre, value: s.idLista } );
      } );
      this.carInformacionInicial = false;
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPerfilRiesgo: [ this.perfil ? this.perfil.idPerfilRiesgo : null ],
      codigo: [ this.perfil ? this.perfil.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombreRiesgo: [ this.perfil ? this.perfil.nombreRiesgo : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      descripcion: [ this.perfil ? this.perfil.descripcion : null, [ Validators.maxLength( 500 ) ] ],
      rangoMinimo: [ this.perfil ? this.perfil.rangoMinimo : null, [ Validators.maxLength( 15 ) ] ],
      rangoMaximo: [ this.perfil ? this.perfil.rangoMaximo : null, [ Validators.maxLength( 15 ) ] ],
      frecuenciaDias: [ (this.perfil && this.perfil.indicadorConsultaAutomatica && this.perRiesgoEstadoAutomatico) ?  this.perRiesgoEstadoAutomatico.frecuenciaDias : null, (this.perfil && this.perfil.indicadorConsultaAutomatica) ? [Validators.required] : [] ],
      orden: [ (this.perfil && this.perfil.orden) ? this.perfil.orden : this.nextOrder ],
      idAdjunto: [ this.perfil ? this.perfil.idAdjunto : null, [ Validators.required ] ],
      idEstado: [ this.perRiesgoEstado ? this.perRiesgoEstado.idEstado : null ],
      idEstadoCambio: [ (this.perfil && this.perfil.indicadorConsultaAutomatica && this.perRiesgoEstadoAutomatico && this.perRiesgoEstadoAutomatico.indicadorHabilitado) ?  this.perRiesgoEstadoAutomatico.idEstado : null, (this.perfil && this.perfil.indicadorConsultaAutomatica) ? [Validators.required] : [] ],
      idCausalSolicitud: [ this.perfil ? this.perfil.idCausalSolicitud : null, [ Validators.required ] ],
      indicadorManejaCiclos: [ this.perfil ? this.perfil.indicadorManejaCiclos : false ],
      indicadorConsultaAutomatica: [ this.perfil ? this.perfil.indicadorConsultaAutomatica : false, [ Validators.required ] ],
      indicadorCambioEstado: [ this.perfil ? this.perfil.indicadorCambioEstado : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.perfil ? this.perfil.indicadorHabilitado : true ],
      indicadorScore: [ this.perfil ? this.perfil.indicadorScore : false ],
      auditoriaUsuario: [ this.perfil ? this.perfil.auditoriaUsuario : null ],
      auditoriaFecha: [ this.perfil ? this.perfil.auditoriaFecha : null ],
    } );
  }

  onSubmit() {
    this.submitted = true;
    this.superaMaximo = false;

    const inferior = Number( this.f.rangoMinimo.value );
    const superior = Number( this.f.rangoMaximo.value );

    if ( (this.f.rangoMinimo.value || this.f.rangoMaximo.value) && (!this.f.rangoMinimo.value || !this.f.rangoMaximo.value || inferior > superior) ) {
      this.superaMaximo = true;
    }

    if ( !this.codExiste && this.formulario.valid && !this.superaMaximo ) {
      this.guardando = true;
      const datPerfil = this.formulario.value;
      if ( datPerfil.idPerfilRiesgo ) {
        /** se actualiza el perfil de riesgo */
        this.perRiesgoServicio.actualizar( datPerfil ).subscribe( rta => {
          this.perfil = datPerfil;
          if ( datPerfil.indicadorConsultaAutomatica ) {
            if ( this.perRiesgoEstadoAutomatico ) {
              this.perRiesgoEstadoAutomatico.idEstado = datPerfil.idEstadoCambio;
              this.perRiesgoEstadoAutomatico.frecuenciaDias = datPerfil.frecuenciaDias;
            } else {
              this.perRiesgoEstadoAutomatico = {} as PerfilRiesgoEstadoAutomatico;
              this.perRiesgoEstadoAutomatico.idEstado = datPerfil.idEstadoCambio;
              this.perRiesgoEstadoAutomatico.frecuenciaDias = datPerfil.frecuenciaDias;
              this.perRiesgoEstadoAutomatico.idPerfilRiesgo = this.perfil.idPerfilRiesgo;
            }
            ((this.perRiesgoEstadoAutomatico && (this.perRiesgoEstadoAutomatico.idPerfilRiesgoEstadoAutomatico !== null && this.perRiesgoEstadoAutomatico.idPerfilRiesgoEstadoAutomatico !== undefined && this.perRiesgoEstadoAutomatico.idPerfilRiesgoEstadoAutomatico !== '')) ?
              this.perRiesgoEstadoAutomaticoServicio.actualizar( this.perRiesgoEstadoAutomatico ) :
              this.perRiesgoEstadoAutomaticoServicio.crear( this.perRiesgoEstadoAutomatico )).subscribe( pRiesgoAuto => {
              this.perRiesgoEstadoAutomatico = pRiesgoAuto;
              this.validarGuardadoEstado( this.perfil, false, datPerfil.idEstado );
            } );
          } else {
            this.validarGuardadoEstado( this.perfil, false, datPerfil.idEstado );
          }

        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      } else {
        /** se crea el perfil de riesgo */
        this.perRiesgoServicio.crear( datPerfil ).subscribe( rta => {
          this.perfil = datPerfil;
          this.perfil.idPerfilRiesgo = rta.idPerfilRiesgo;
          this.f.idPerfilRiesgo.setValue( rta.idPerfilRiesgo );
          if ( datPerfil.indicadorConsultaAutomatica ) {
            const perRieAuto = {} as PerfilRiesgoEstadoAutomatico;
            perRieAuto.idEstado = datPerfil.idEstadoCambio;
            perRieAuto.frecuenciaDias = datPerfil.frecuenciaDias;
            perRieAuto.idPerfilRiesgo = this.perfil.idPerfilRiesgo;
            this.perRiesgoEstadoAutomaticoServicio.crear( perRieAuto ).subscribe( pRiesgoAuto => {
              this.perRiesgoEstadoAutomatico = pRiesgoAuto;
              this.validarGuardadoEstado( this.perfil, true, datPerfil.idEstado );
            } );
          } else {
            this.validarGuardadoEstado( this.perfil, true, datPerfil.idEstado );
          }

        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }

  validarConsultaAutomatica() {
    this.f.frecuenciaDias.setValidators( this.f.indicadorConsultaAutomatica.value ? [ Validators.required ] : [] );
    this.f.idEstadoCambio.setValidators( this.f.indicadorConsultaAutomatica.value ? [ Validators.required ] : [] );
    this.f.frecuenciaDias.setValue( null );
    this.f.idEstadoCambio.setValue( null );
  }

  validarGuardadoEstado( perRiesgo: PerfilRiesgo, crear: boolean, idEstado: string ) {
    if ( perRiesgo.indicadorCambioEstado ) {
      const a = this.perRiesgoEstado ? this.perRiesgoEstado : {} as PerfilRiesgoEstado;
      a.indicadorHabilitado = true;
      a.idEstado = idEstado;
      a.idPerfilRiesgo = perRiesgo.idPerfilRiesgo;
      (this.perRiesgoEstado ? this.perRiesgoEstadoServicio.actualizar( a ) : this.perRiesgoEstadoServicio.crear( a )).subscribe( rta => {
        this.perRiesgoEstado = rta;
        this.finalizarGuardadoPerfil( crear );
      } );
    } else if ( this.perRiesgoEstado && this.perRiesgoEstado.indicadorHabilitado ) {
      this.perRiesgoEstado.indicadorHabilitado = false;
      this.perRiesgoEstadoServicio.actualizar( this.perRiesgoEstado ).subscribe( guardado => {
        this.finalizarGuardadoPerfil( crear );
      } );
    } else {
      this.finalizarGuardadoPerfil( crear );
    }
  }

  finalizarGuardadoPerfil( crear: boolean ) {
    this.navServicio.setMesage( crear ? 1 : 2 );
    this.guardando = false;
    this.tabSeleccionado = 'TASA';
  }

  validarCambioEstado() {
    this.f.idEstado.setValidators( (this.f.indicadorCambioEstado.value ? [ Validators.required ] : []) );
    this.f.idEstado.setValue( null );
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisPerfiles.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'TASA';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'CICLO';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'SCORE';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  onBeforeSend( event: any ) {
    this.carImagen = true;
    this.adjServicio.cargarArchivo( event, this.nomArchivo, 'Perfiles' );
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body;
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.f.idAdjunto.setValue( respuesta.idAdjunto );
      this.carImagen = false;
    }
  }

  onSelect( event: any, file: any ) {
    this.nomArchivo = file[ 0 ].name;
    let reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = reader.result;
    }, false );
    if ( file[ 0 ] ) {
      reader.readAsDataURL( file[ 0 ] );
    }
  }

  private sortItems() {
    this.lisPerfiles.sort( function( a, b ) {
      if ( a.orden < b.orden ) {
        return -1;
      } else {
        return 1;
      }
    } );
  }

}
